import { render, staticRenderFns } from "./TalentService.vue?vue&type=template&id=9712ffc0&scoped=true"
import script from "./TalentService.vue?vue&type=script&lang=js"
export * from "./TalentService.vue?vue&type=script&lang=js"
import style0 from "./TalentService.vue?vue&type=style&index=0&id=9712ffc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9712ffc0",
  null
  
)

export default component.exports